export const productCopy = {
  "da-DK": {
    "product.uploadRequest.unknown": "Du har ikke valgt et interval endnu.",
    "product.uploadRequest.queued": "Venter på at sende ændringen.",
    "product.uploadRequest.sent": "Ændringen er sendt. Venter på svar.",
    "product.uploadRequest.replied": "Trackeren har accepteret ændringen.",
    "product.uploadRequest.failed": "Ændringen kunne ikke sendes.",
    "product.zoneRemove": "Fjern zone",
    "product.zoneRemoveReview": "Fjern sikkerhedszonen? Nye zonehændelser stopper. Gemte positioner og hændelser bevares.",
    "product.zoneRemoved": "Sikkerhedszonen er fjernet.",
    "product.zoneRemoveFailed": "Fjernelsen kunne ikke bekræftes. Kontrollér dine områder, før du prøver igen.",

    "feature.locationSourcesSummary": "Position fra GPS, mobilnet og Wi-Fi",
    "feature.gpsFenceSummary": "Besked ved ankomst eller afgang fra et område",
    "feature.wifiFenceSummary": "Genkend hjemmet via dit trådløse netværk",
    "feature.fallSensitivitySummary": "Hvor følsomt armbåndet skal reagere på et fald",
    "feature.restartSummary": "Sluk og start armbåndet igen",
    "feature.faqSummary": "Hjælp til SIM-kort, forbindelse og betjening",
    "feature.deviceInfoSummary": "Oplysninger om dit armbånd og SIM-kort",
    "feature.voiceMonitorSummary": "Bed armbåndet ringe til et valgt nummer",
    "product.zoneReview": "Gem GPS-zonen for {name}?",

 "product.previousPeriod":"Forrige periode","product.nextPeriod":"Næste periode","product.previousRecord":"Forrige rekord","product.nextRecord":"Næste rekord","product.dailyChart":"Udvikling pr. dag","product.monthlyChart":"Udvikling pr. måned",
    "product.customize": "Tilpas",
    "product.save": "Gem",
    "product.cancel": "Annuller",
    "product.restore": "Gendan standard",
    "product.up": "Flyt op",
    "product.down": "Flyt ned",
    "product.dashboardHelp": "Vælg det, du vil se, og flyt elementerne i den rækkefølge, der passer dig. Valget gemmes på din konto.",
    "product.card.status": "Forbindelse og hændelser",
    "product.card.map": "Kort",
    "product.card.battery": "Batteri og seneste kontakt",
    "product.card.activity": "Dagens aktivitet",
    "product.card.health": "Seneste målinger",
    "product.card.events": "Seneste hændelser",
    "product.noReadings": "Ingen målinger endnu",
    "product.noNewEvents": "Ingen nye hændelser",
    "product.viewMap": "Se position og rute",
    "product.viewActivity": "Se aktivitet",
    "product.viewCare": "Se målinger",
    "product.dataHelp": "Oplysninger opdateres automatisk. Tidspunktet fortæller, hvornår vi sidst hørte fra armbåndet.",
    "product.positionHelp": "Kortet bruger armbåndets seneste kendte GPS-position. En gammel eller manglende position kan skyldes dårlig dækning.",
    "product.mapProblem": "Kortet er ikke indlæst. Prøv Genindlæs kort.",
    "product.mapPreview": "Åbn kortet i Qtracker på telefonen.",
    "product.upload": "Opdateringsinterval",
    "product.uploadHelp": "Vælg, hvor ofte armbåndet skal sende en position. Hyppige opdateringer bruger mere batteri. Et svar betyder, at anmodningen er modtaget; den faktiske rytme afhænger også af armbånd og dækning.",
    "product.uploadConfirm": "Skift interval til {interval}?",
    "product.uploadSaved": "Senest valgt: {interval}",
    "product.uploadNotSet": "Vælg et interval",
    "product.quality": "Forbindelse og GPS",
    "product.qualityHelp": "Vælg et tidsrum for at se GPS-dækning og batteriudvikling. Det ændrer kun oversigten, ikke enhedens indstillinger.",
    "product.period": "Statistikperiode",
    "product.sourceTitle": "Positionskilder",
    "product.sourceGps": "GPS-positioner",
    "product.sourceMobile": "Udelad omtrentlige positioner fra mobilnettet",
    "product.sourceWifi": "Udelad omtrentlige positioner fra Wi-Fi",
    "product.sourceMobileHelp": "Mobilmaster kan give en omtrentlig placering, når GPS mangler. De er typisk mindre præcise. Denne app bruger endnu kun GPS, så valget kan ikke ændres her.",
    "product.sourceWifiHelp": "Kendte Wi-Fi-netværk kan bruges til at anslå en placering. Appen bruger endnu ikke disse positioner. Dette er noget andet end en Wi-Fi-sikkerhedszone.",
    "product.gpsOnly": "GPS er den aktive positionskilde",
    "product.unavailable": "Ikke tilgængelig endnu",
    "product.zoneTitle": "GPS-sikkerhedszone",
    "product.zoneHelp": "Tryk på kortet for at vælge centrum, og vælg områdets størrelse. Nye GPS-positioner bruges til at registrere ankomst og afgang. Slå beskeder til under Enhed → Telefonnotifikationer.",
    "product.zoneRadius": "Områdets radius",
    "product.zoneNotify": "Hvornår vil du have besked?",
    "product.zone.enter": "Ved ankomst",
    "product.zone.exit": "Ved afgang",
    "product.zone.both": "Ved ankomst og afgang",
    "product.on": "Aktiveret",
    "product.off": "Deaktiveret",
    "product.zoneUsePosition": "Brug armbåndets position",
    "product.zonePick": "Vælg centrum på kortet",
    "product.zoneSaved": "Sikkerhedszonen er gemt",
    "product.zoneSaveFailed": "Ændringen kunne ikke bekræftes. Din kladde er bevaret. Kontrollér dine områder, før du prøver igen.",
    "product.zoneSavedState": "Gemt: {state}",
    "product.wifiHelp": "Området genkendes via tre 2,4 GHz-Wi-Fi-netværk. Indtast netværkenes MAC-adresser fra routerens indstillinger. Området kan ikke fjernes fra enheden i appen endnu.",
    "product.wifiDisable": "Deaktivering er endnu ikke understøttet",
    "product.findPending": "Anmodning sendt. Lyt efter armbåndet.",
    "product.findFailed": "Armbåndet svarede ikke. Kontrollér forbindelsen.",
    "product.measureHelp": "Start en måling, og hold armbåndet i ro. Tidligere resultater findes i historikken. Målingerne erstatter ikke en lægefaglig vurdering.",
    "product.measuring": "Måler…",
    "product.settingSaved": "Senest valgt",
    "product.settingHelp": "Vælg en indstilling, og tryk Gem. Enheden skal have forbindelse for at modtage ændringen.",
    "product.eventsHelp": "Se dine hændelser, og markér dem som håndteret, når du har fulgt op. Beskeder til telefonen vælges under Telefonnotifikationer.",
    "product.activityHelp": "Tal med betegnelsen Estimeret beregnes ud fra GPS og din profil. Gennemsnit bruger dage med data. Manglende registreringer tæller ikke som nul. Tryk på en søjle for at se dagen eller måneden.",
    "product.activityRecordsHelp": "Rekorder gælder den valgte periode. Højeste fart kan også være fra transport.",
    "product.selectDate": "Vælg dato",
    "product.averages": "Gennemsnit og aktive dage",
    "product.chart.steps": "Skridt",
    "product.chart.distance": "Distance",
    "product.chart.calories": "Kalorier",
    "product.chart.activity": "Aktiv tid",
    "product.record": "Periodens rekord",
    "product.account": "Konto og adgang",
    "product.language": "Sprog",
    "product.appearance": "Udseende",
    "control.filterLbs": "Udelad positioner fra mobilnettet",
    "control.filterWifi": "Udelad positioner fra Wi-Fi",
    "control.alarmDirection": "Hvornår vil du have besked?",
    "feature.status.gated": "Ikke tilgængelig endnu",
    "feature.status.locked": "Ikke tilgængelig endnu",
    "feature.status.gatedBody": "Funktionen er ikke tilgængelig på denne enhed. Her vises kun et eksempel.",
    "feature.status.lockedBody": "Funktionen er ikke tilgængelig endnu.",
    "feature.voiceTalk": "Talebeskeder",
    "feature.voiceMonitor": "Bed armbåndet ringe tilbage"
  },
  "en-GB": {
    "product.uploadRequest.unknown": "You have not chosen an interval yet.",
    "product.uploadRequest.queued": "Waiting to send the change.",
    "product.uploadRequest.sent": "Change sent. Waiting for a reply.",
    "product.uploadRequest.replied": "The tracker accepted the change.",
    "product.uploadRequest.failed": "The change could not be sent.",
    "product.zoneRemove": "Remove zone",
    "product.zoneRemoveReview": "Remove the safety zone? New zone events stop. Saved positions and events are kept.",
    "product.zoneRemoved": "The safety zone has been removed.",
    "product.zoneRemoveFailed": "Removal could not be confirmed. Check your areas before trying again.",

    "feature.locationSourcesSummary": "Position from GPS, mobile networks and Wi-Fi",
    "feature.gpsFenceSummary": "Events when arriving at or leaving an area",
    "feature.wifiFenceSummary": "Recognise home using your wireless network",
    "feature.fallSensitivitySummary": "How sensitively the bracelet detects a fall",
    "feature.restartSummary": "Turn the bracelet off and on again",
    "feature.faqSummary": "Help with the SIM card, connection and controls",
    "feature.deviceInfoSummary": "Information about your bracelet and SIM card",
    "feature.voiceMonitorSummary": "Ask the bracelet to call a chosen number",
    "product.zoneReview": "Save the GPS zone for {name}?",

 "product.previousPeriod":"Previous period","product.nextPeriod":"Next period","product.previousRecord":"Previous record","product.nextRecord":"Next record","product.dailyChart":"Daily progress","product.monthlyChart":"Monthly progress",
    "product.customize": "Customize",
    "product.save": "Save",
    "product.cancel": "Cancel",
    "product.restore": "Restore defaults",
    "product.up": "Move up",
    "product.down": "Move down",
    "product.dashboardHelp": "Choose what to see and arrange the items. Your choices are saved to your account.",
    "product.card.status": "Connection and events",
    "product.card.map": "Map",
    "product.card.battery": "Battery and last contact",
    "product.card.activity": "Today’s activity",
    "product.card.health": "Latest readings",
    "product.card.events": "Latest events",
    "product.noReadings": "No readings yet",
    "product.noNewEvents": "No new events",
    "product.viewMap": "View position and route",
    "product.viewActivity": "View activity",
    "product.viewCare": "View readings",
    "product.dataHelp": "Information updates automatically. The time shows when the bracelet was last in contact.",
    "product.positionHelp": "The map uses the bracelet’s last known GPS position. An old or missing position may be caused by poor reception.",
    "product.mapProblem": "The map has not loaded. Try Reload map.",
    "product.mapPreview": "Open the map in Qtracker on your phone.",
    "product.upload": "Location update interval",
    "product.uploadHelp": "Choose how often the bracelet should send a position. Frequent updates use more battery. A reply confirms receipt; the actual rhythm also depends on the bracelet and reception.",
    "product.uploadConfirm": "Change interval to {interval}?",
    "product.uploadSaved": "Last requested: {interval}",
    "product.uploadNotSet": "Choose an interval",
    "product.quality": "Connection and GPS",
    "product.qualityHelp": "Choose a period to see GPS coverage and battery change. This changes the view, not the device settings.",
    "product.period": "Statistics period",
    "product.sourceTitle": "Location sources",
    "product.sourceGps": "GPS positions",
    "product.sourceMobile": "Exclude approximate mobile-network positions",
    "product.sourceWifi": "Exclude approximate Wi-Fi positions",
    "product.sourceMobileHelp": "Mobile towers can provide an approximate position when GPS is unavailable. They are usually less precise. This app currently uses GPS only, so this setting cannot yet be changed.",
    "product.sourceWifiHelp": "Known Wi-Fi networks can help estimate a position. The app does not use these positions yet. This is separate from a Wi-Fi safe zone.",
    "product.gpsOnly": "GPS is the active location source",
    "product.unavailable": "Not available yet",
    "product.zoneTitle": "GPS safe zone",
    "product.zoneHelp": "Select the centre on the map and choose the area size. New GPS positions detect entry and exit. Enable alerts under Device → Phone notifications.",
    "product.zoneRadius": "Area radius",
    "product.zoneNotify": "When should an event be recorded?",
    "product.zone.enter": "On arrival",
    "product.zone.exit": "On departure",
    "product.zone.both": "On arrival and departure",
    "product.on": "Enabled",
    "product.off": "Disabled",
    "product.zoneUsePosition": "Use bracelet position",
    "product.zonePick": "Choose the centre on the map",
    "product.zoneSaved": "Safe zone saved",
    "product.zoneSaveFailed": "The change could not be confirmed. Your draft is kept. Check your areas before trying again.",
    "product.zoneSavedState": "Saved: {state}",
    "product.wifiHelp": "The area is recognised using three 2.4 GHz Wi-Fi networks. Enter their MAC addresses from the router settings. The area cannot be removed from the device in the app yet.",
    "product.wifiDisable": "Disabling is not yet supported",
    "product.findPending": "Request sent. Listen for the bracelet.",
    "product.findFailed": "The bracelet did not reply. Check the connection.",
    "product.measureHelp": "Start a reading and keep the bracelet still. Previous results are in history. Readings do not replace professional medical assessment.",
    "product.measuring": "Measuring…",
    "product.settingSaved": "Last requested",
    "product.settingHelp": "Choose a setting and select Save. The device must be connected to receive the change.",
    "product.eventsHelp": "View events and mark them as handled once you have responded. Choose phone alerts under Phone notifications.",
    "product.activityHelp": "Values labelled Estimated use GPS and your profile. Averages use days with data. Missing records are not counted as zero. Tap a bar to see its day or month.",
    "product.activityRecordsHelp": "Records apply to the selected period. Highest speed may include transport.",
    "product.selectDate": "Choose date",
    "product.averages": "Averages and active days",
    "product.chart.steps": "Steps",
    "product.chart.distance": "Distance",
    "product.chart.calories": "Calories",
    "product.chart.activity": "Active time",
    "product.record": "Period record",
    "product.account": "Account and access",
    "product.language": "Language",
    "product.appearance": "Appearance",
    "control.filterLbs": "Exclude mobile-network positions",
    "control.filterWifi": "Exclude Wi-Fi positions",
    "control.alarmDirection": "When should you be notified?",
    "feature.status.gated": "Not available yet",
    "feature.status.locked": "Not available yet",
    "feature.status.gatedBody": "This feature is unavailable on this device. This is a preview only.",
    "feature.status.lockedBody": "This feature is not available yet.",
    "feature.voiceTalk": "Voice messages",
    "feature.voiceMonitor": "Request a callback"
  }
};
